<template>
  <el-table
    :data="participants"
    border
    style="width: 100%"
    :cell-class-name="cellClassName"
    max-height="680"
    :header-cell-class-name="headerCellClassName"
  >
    <el-table-column
      :fixed="isSmallView || noData || isArabianLang() ? null : 'left'"
      :label="$t('promotion.referFriends.fName')"
      width="252"
    >
      <template slot-scope="scope">
        <ReferralCell :name="scope.row.realName" :country="getCountryName(scope.row.countryId)" />
      </template>
    </el-table-column>
    <el-table-column :label="$t('promotion.referFriends.registered')" width="170">
      <template slot-scope="scope">
        <VoucherContainer v-bind="voucherFor(scope.row.vouchers, 0)" />
      </template>
    </el-table-column>
    <el-table-column :label="$t('promotion.referFriends.statusAccountOpened')" width="170">
      <template slot-scope="scope">
        <VoucherContainer v-bind="voucherFor(scope.row.vouchers, 1)" />
      </template>
    </el-table-column>
    <el-table-column :label="$t('promotion.referFriends.madeDeposit')" width="170">
      <template slot-scope="scope">
        <VoucherContainer v-bind="isTierOne(scope.row.tier) ? voucherFor(scope.row.vouchers, 2) : null" />
      </template>
    </el-table-column>
    <el-table-column :label="$t('promotion.referFriends.tradedTwoLots')" width="170">
      <template slot-scope="scope">
        <VoucherContainer v-bind="isTierOne(scope.row.tier) ? voucherFor(scope.row.vouchers, 3) : null" />
      </template>
    </el-table-column>
    <el-table-column :label="$t('promotion.referFriends.tradedFiveLots')" width="190">
      <template slot-scope="scope">
        <VoucherContainer
          v-bind="isTierOne(scope.row.tier) ? voucherFor(scope.row.vouchers, 4) : voucherFor(scope.row.vouchers, 2)"
        />
      </template>
    </el-table-column>
    <el-table-column :fixed="isSmallView || noData || isArabianLang() ? null : 'right'" label="" width="230">
      <template slot-scope="scope">
        <Redeem
          v-bind="
            getRedeemProps({
              tier: scope.row.tier,
              vouchers: scope.row.vouchers,
              index: scope.$index,
              status: scope.row.participantStatus
            })
          "
          @click="onClickRedeem(scope.row)"
        />
      </template>
    </el-table-column>
    <div slot="empty" class="empty">
      <img class="noData_icon" src="@/assets/images/no_data.png" alt />
      <div>{{ $t('loyalty.noData') }}</div>
    </div>
  </el-table>
</template>

<script>
import ReferralCell from './ReferralCell.vue';
import VoucherContainer from './VoucherContainer.vue';
import { STATUS } from '../constants/voucher';
import Redeem from './Redeem.vue';
import { isTierOne, canRedeem, isAllRedeemed, hideRedeemButton } from '../helpers/voucher';

export default {
  name: 'ReferralsTable',
  components: {
    ReferralCell,
    VoucherContainer,
    Redeem
  },
  props: {
    participants: {
      type: Array,
      default: () => {
        return [];
      }
    },
    refereeLimit: {
      type: Number,
      default: () => {
        return 10;
      }
    },
    countriesMap: {
      type: Object
    }
  },
  data() {
    return {
      tableHeaderStyle: {
        background: '#fff'
      },
      isSmallView: window.innerWidth < 625,
      noData: this.participants.length < 1
    };
  },
  methods: {
    cellClassName({ row, column, rowIndex, columnIndex }) {
      const LAST_COLUMNINDEX = 6;
      return `table-cell ${columnIndex === 0 || columnIndex === LAST_COLUMNINDEX ? '' : 'table-cell-grey'}`;
    },
    headerCellClassName({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return 'header-cell-first';
      }
      return 'header-cell';
    },
    getCountryName(code) {
      return this.countriesMap[code] || '';
    },
    isTierOne,
    voucherFor(vouchers, index) {
      return vouchers[index] || null;
    },
    isOverLimit(index) {
      return index >= this.refereeLimit;
    },
    getRedeemProps({ tier, vouchers, index, status }) {
      if (this.isOverLimit(index)) {
        return {
          isOverLimit: true,
          isRedeemable: false
        };
      }

      if (
        status === 'REFERRER_REQUEST_CLAIM_VOUCHER' ||
        status === 'POSTPONE_CLAIM' ||
        status === 'WAIT_CLAIM' ||
        status === 'WAIT_CLAIM_PHASE_2' ||
        status === 'WAIT_CLAIM_PHASE_3'
      ) {
        return {
          isDisabledButton: true
        };
      }

      if (status === 'REJECT_CLAIM') {
        return {
          isRejected: true
        };
      }

      if (status === 'STOP') {
        return {
          isExpired: true
        };
      }

      if (hideRedeemButton({ vouchers, tier })) {
        return {
          isHideRedeemButton: true
        };
      }

      if (canRedeem({ vouchers, tier })) {
        return {
          isRedeemable: true,
          isAllRedeemed: false
        };
      }

      if (isAllRedeemed({ vouchers, tier })) {
        return {
          isRedeemable: false,
          isAllRedeemed: true
        };
      }

      return {
        isRedeemable: false,
        isAllRedeemed: false
      };
    },
    getValidVoucherTotalAmount(vouchers) {
      return vouchers.reduce((acc, { status, amount }) => {
        if (status === STATUS.VALID) {
          acc += amount;
        }
        return acc;
      }, 0);
    },
    onClickRedeem(rowData) {
      this.$emit('clickRedeem', [rowData.participantId], this.getValidVoucherTotalAmount(rowData.vouchers));
    },
    isArabianLang() {
      return this.$store.state.common.lang === 'ar';
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/referFriends/referrals/referralsTable.scss';
</style>
